import React from 'react';
import styles from './Page.module.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
const Section = ({ children, center }) => {
    return <div className={classNames(styles.section, { [styles['section--center']]: center })}>{children}</div>;
};

export default Section;

Section.propTypes = {
    children: PropTypes.node,
    center: PropTypes.bool
};
